import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initI18n } from './i18n';

// Marqueur native pour le CSS scopé : overscroll-behavior contain ne
// s'applique qu'en app Capacitor (fix tab bar iOS), pas en web où il
// bloque le scroll trackpad Chrome Mac.
if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add('is-native');
  document.body.classList.add('is-native');
}

// On attend l'init i18n AVANT le premier render React (cf. frontend/src/i18n/index.js).
// Le timeout détection geoip est de 800ms — si l'API met plus, on bascule sur le
// fallback navigator.language puis sur 'fr', donc l'attente reste bornée.
initI18n()
  .catch((err) => {
    // Si l'init i18next plante (cas extrême), on log et on render quand même
    // — i18n garde sa lng par défaut (fr) et l'app reste fonctionnelle.
    console.error('[i18n] init failed:', err && err.message);
  })
  .finally(() => {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    if (Capacitor.isNativePlatform()) {
      // Petite latence pour laisser React faire le premier paint
      setTimeout(() => {
        SplashScreen.hide({ fadeOutDuration: 300 }).catch(() => {});
      }, 800);
    }
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
